<template>
    <div class="border" style="resize:vertical;overflow:auto;max-height:100ex">
        <pre class="bg-white px-1 py-3">{{ this.audit_log }}</pre>
    </div>
</template>

<style>
    
</style>

<script>
export default {
    // name: 'AuditLog,

    mounted() {
        axios
        .get('/api/admin/audit')
        .then(
            (response) => { 
                console.log(response);
                this.audit_log = response.data.audit_log;
            });

    },

    data() {
        return {
            audit_log: ''
        }
    }
}
</script>